


































import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';

import storeAchat from '@/stores/modules/achat';

import InputReglementsList from '@/components/Input/ReglementsList.vue';
import {Achat} from "@/models";

@Component({
	components: {
		InputReglementsList,
	}
})
export default class CrudAchatEditReglement extends AbstractEditVue<Achat> {
	public constructor() {
		super(
			storeAchat,
			'Réglement modifié',
			'Réglement créé',
		);
	}

}
